export default __webpack_public_path__ + "static/media/NIAS0370.34I-34820_-19528_0.0ecaf0c0.jpg";